export { default } from './FormPasswordInput';
